export default "__VITE_ASSET__RK58kqci__"